import HPTMedicareRelativityTool from './view';
import {createHPTQuery} from './filter-steps/institutional-steps/query';
import hptFilterStepsConfig from './filter-steps/institutional-steps/hpt-filter-steps-config';
import {useMemo} from 'react';
import HPTInstitutionalFilterStepsStore from './filter-steps/institutional-steps/steps/institutional-store';
export default function HPTInstitutionalTool() {
    const hptFilterStore = useMemo(() => HPTInstitutionalFilterStepsStore.empty(), []);
    return <HPTMedicareRelativityTool createHPTQuery={createHPTQuery} filterSteps={hptFilterStepsConfig} hptFilterStore={hptFilterStore} title="Milliman Insights" />;
}